import { LogoIcon } from '@/components/icons/logo'

interface ChartWatermarkSvgProps {
  height?: number
  offset?: {
    height: number
    left: number
    top: number
    width: number
  }
  width?: number
}

const WATERMARK_LOGO_SIZE = 28
const WATERMARK_TEXT_WIDTH = 58
const WATERMARK_GAP = 4
const WATERMARK_RIGHT_OFFSET = 8
const WATERMARK_BOTTOM_OFFSET = 22

type ChartWatermarkComponent = ((props: ChartWatermarkSvgProps) => JSX.Element | null) & {
  displayName?: string
}

export const ChartWatermark: ChartWatermarkComponent = (props) => {
  return <ChartWatermarkSvg {...props} />
}

ChartWatermark.displayName = 'Customized'

const ChartWatermarkSvg = ({ height = 0, offset, width = 0 }: ChartWatermarkSvgProps) => {
  const rightX = (offset ? offset.left + offset.width : width) - WATERMARK_RIGHT_OFFSET
  const centerY = (offset ? offset.top + offset.height : height) - WATERMARK_BOTTOM_OFFSET
  const logoX = rightX - WATERMARK_TEXT_WIDTH - WATERMARK_GAP - WATERMARK_LOGO_SIZE
  const logoY = centerY - WATERMARK_LOGO_SIZE / 2

  if (rightX <= 0 || centerY <= 0) {
    return null
  }

  return (
    <g pointerEvents="none" opacity={0.3}>
      <LogoIcon size={WATERMARK_LOGO_SIZE} x={logoX} y={logoY} />
      <text
        x={rightX}
        y={centerY + 5}
        fill="rgb(var(--heading-foreground))"
        fontSize={14}
        fontWeight={500}
        textAnchor="end"
      >
        vaults.fyi
      </text>
    </g>
  )
}
